export const GREEN_COLOR = '#26a69a';
export const RED_COLOR = '#ef5350';

export const RED_BOTTOM_FILL_COLOR = 'rgba(239, 83, 80, 0.05)';
export const RED_BOTTOM_LINE_COLOR = 'rgba(239, 83, 80, 1)';
export const RED_GRADIENT_START = 'rgba(239, 83, 80, 0.6)';
export const RED_GRADIENT_END = 'rgba(239, 83, 80, 1)';

export const GREEN_TOP_FILL_COLOR = 'rgba(38, 166, 154, 0.28)';
export const GREEN_TOP_LINE_COLOR = 'rgba(38, 166, 154, 1)';
export const GREEN_GRADIENT_START = 'rgba(38, 166, 154, 0.5)';
export const GREEN_GRADIENT_END = 'rgba(38, 166, 154, 0.9)';

export const ORANGE_GRADIENT_START = 'rgba(255, 152, 0, 0.6)';
export const ORANGE_GRADIENT_END = 'rgba(255, 152, 0, 1)';

export const BRIGHT_GREEN_GRADIENT_START = 'rgba(76, 175, 80, 0.6)';
export const BRIGHT_GREEN_GRADIENT_END = 'rgba(76, 175, 80, 1)';

export const ROBOTO_FONT = "'Roboto', sans-serif";
